<template>
  <div>
    <span v-show="loading" class="spinner-border spinner-border-xl"></span>
    <div
      v-for="attachment in attachmentList"
      :key="attachment.dokumentPrilogaId"
      class="list-group list-group-flush"
    >
      <div class="list-group-item" @click="downloadAttachment(attachment.dokumentPrilogaId)">
        <div class="list-group-item-figure">
          <a
            class="tile tile-lg bg-purple"
          ></a>
        </div>
        <div class="list-group-item-body">
          <h5 class="card-title">
            <a>{{ attachment.datotekaNaziv }}</a>
          </h5>
          <p class="card-subtitle text-muted mb-1">Kreirano: {{ formatDate(attachment.vnosDatum)}}</p>
        </div>
      </div>
    </div>
    <div v-if="message" class="alert alert-danger" role="alert">{{message}}</div>
  </div>
</template>

<script>
import DokumentService from "../services/dokument.service";
import moment from "moment";

export default {
  name: "AttachmentPage",
  props: {
    dokumentId: String,
  },
  data() {
    return {
      comment: "",
      attachmentList: [],
      message: "",
      loading: false,
    };
  },
  methods: {
    loadAttachments() {
      this.loading = true;
      DokumentService.getAttachments(this.dokumentId).then(
        (response) => {
          this.attachmentList = response.data;
          this.loading = false;
        },
        () => {
          this.loading = false;
          this.message =
            "Prišlo je do napake! Poskusite ponovno čez nekaj minut.";
        }
      );
    },
    downloadAttachment(dokumentPrilogaId) {
      DokumentService.getAttachment(dokumentPrilogaId).then(
        (response) => {
          let blob = new Blob([response.data], {
              type: response.headers["content-type"],
              size: response.headers["content-length"]
            }),
            url = window.URL.createObjectURL(blob);

          window.location = url;
        },
        () => {
          this.message =
            "Prišlo je do napake! Poskusite ponovno čez nekaj minut.";
        }
      );
    },
    formatDate(date) {
      return moment(date).format("DD.MM.YYYY HH:MM")
    }
  },
  mounted() {
    this.loadAttachments();
  },
};
</script>

<style scoped>
</style>
